export default __webpack_public_path__ + "static/media/secondary-bg-grey.f9aeea86.png";